import { generatePath, useParams } from "react-router-dom";
import { ROUTES } from "./paths";
import { UrlQueryObject } from "@/lib/UrlSerializers";
import { convertToQueryString } from "@/hooks/useUrlSerializer";

const BASE_ROUTE = ROUTES.ORGANIZATION;

const ROUTE_MAP = {
  home: [],
  nowhere: [ROUTES.NOWHERE],
  chat: [ROUTES.CHAT.INDEX],
  selectedChat: [ROUTES.CHAT.SELECTED_CHAT],
  communityTools: [ROUTES.COMMUNITY_TOOLS.BASE],
  adoptionAndEngagement: [ROUTES.ANALYTICS.BASE, ROUTES.ANALYTICS.ADOPTION],
  createBulkMessage: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.BASE,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.SEND_NOW,
  ],
  bulkMessageBasicInfo: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.BASE,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.SEND_NOW,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.BASIC_INFORMATION,
  ],
  bulkMessageCompose: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.BASE,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.SEND_NOW,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.COMPOSE_MESSAGE,
  ],
  bulkMessageReview: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.BASE,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.SEND_NOW,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.REVIEW,
  ],
  bulkMessageDetails: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.BASE,
    ":bulkMessageId",
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.DETAILS,
  ],
  bulkMessageCampaignDetails: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.BASE,
    ":bulkMessageId",
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.CAMPAIGN_DETAILS,
  ],
  editEvent: [ROUTES.COMMUNITY_TOOLS.BASE, ROUTES.COMMUNITY_TOOLS.EDIT_EVENT],
  editLiveEvent: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.EDIT_EVENT,
    ROUTES.COMMUNITY_TOOLS.LIVE_EVENT,
  ],
  editGame: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.EDIT_EVENT,
    ROUTES.COMMUNITY_TOOLS.GAME,
  ],
  eventDetails: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.GAMES_AND_LIVE_EVENTS,
    ":eventId",
    ROUTES.COMMUNITY_TOOLS.EVENT_DETAILS.DETAILS,
  ],
  eventResults: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.GAMES_AND_LIVE_EVENTS,
    ":eventId",
    ROUTES.COMMUNITY_TOOLS.EVENT_DETAILS.RESULTS,
  ],
  bulkMessaging: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.BASE,
  ],
  editBulkMessaging: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.BASE,
    ":bulkMessageId",
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.EDIT,
  ],
  editBulkMessagingBasicInfo: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.BASE,
    ":bulkMessageId",
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.EDIT,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.BASIC_INFORMATION,
  ],
  editBulkMessagingCompose: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.BASE,
    ":bulkMessageId",
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.EDIT,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.COMPOSE_MESSAGE,
  ],
  editBulkMessagingReview: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.BASE,
    ":bulkMessageId",
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.EDIT,
    ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.REVIEW,
  ],
  teammates: [
    ROUTES.COMMUNITY_MANAGEMENT.BASE,
    ROUTES.COMMUNITY_MANAGEMENT.MANAGE_TEAM.BASE,
  ],
  sendInvite: [
    ROUTES.COMMUNITY_MANAGEMENT.BASE,
    ROUTES.COMMUNITY_MANAGEMENT.MANAGE_TEAM.BASE,
    ROUTES.COMMUNITY_MANAGEMENT.MANAGE_TEAM.SEND_INVITE,
  ],
  sendInviteDetails: [
    ROUTES.COMMUNITY_MANAGEMENT.BASE,
    ROUTES.COMMUNITY_MANAGEMENT.MANAGE_TEAM.BASE,
    ROUTES.COMMUNITY_MANAGEMENT.MANAGE_TEAM.SEND_INVITE,
    ROUTES.COMMUNITY_MANAGEMENT.MANAGE_TEAM.DETAILS,
  ],
  students: [ROUTES.STUDENTS],
  student: [ROUTES.STUDENT_PROFILE],
  funnel: [ROUTES.ANALYTICS.BASE, ROUTES.ANALYTICS.FUNNEL],
  adoption: [ROUTES.ANALYTICS.BASE, ROUTES.ANALYTICS.ADOPTION],
  engagementData: [
    ROUTES.ANALYTICS.BASE,
    ROUTES.ANALYTICS.ADOPTION,
    ROUTES.ANALYTICS.ENGAGEMENT_DATA,
  ],
  engagementIndex: [
    ROUTES.ANALYTICS.BASE,
    ROUTES.ANALYTICS.ADOPTION,
    ROUTES.ANALYTICS.ENGAGEMENT_INDEX,
  ],
  predictiveModels: [ROUTES.ANALYTICS.BASE, ROUTES.ANALYTICS.PREDICTIVE_MODELS],
  applyIndex: [
    ROUTES.ANALYTICS.BASE,
    ROUTES.ANALYTICS.PREDICTIVE_MODELS,
    ROUTES.ANALYTICS.APPLY_INDEX,
  ],
  commitIndex: [
    ROUTES.ANALYTICS.BASE,
    ROUTES.ANALYTICS.PREDICTIVE_MODELS,
    ROUTES.ANALYTICS.COMMIT_INDEX,
  ],
  meltIndex: [
    ROUTES.ANALYTICS.BASE,
    ROUTES.ANALYTICS.PREDICTIVE_MODELS,
    ROUTES.ANALYTICS.MELT_INDEX,
  ],
  yieldIndex: [
    ROUTES.ANALYTICS.BASE,
    ROUTES.ANALYTICS.PREDICTIVE_MODELS,
    ROUTES.ANALYTICS.YIELD_INDEX,
  ],
  retainIndex: [
    ROUTES.ANALYTICS.BASE,
    ROUTES.ANALYTICS.PREDICTIVE_MODELS,
    ROUTES.ANALYTICS.RETAIN_INDEX,
  ],
  gamesAndLiveEvents: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.GAMES_AND_LIVE_EVENTS,
  ],
  peerMessaging: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.PEER_MESSAGING,
  ],
  competitorMatch: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.COMPETITOR_MATCH,
  ],
  dynamicActionButton: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.DAB,
  ],
  feedPosts: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.FEED_POSTS.BASE,
  ],
  feedPostDetails: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.FEED_POSTS.BASE,
    ":feedPostId",
    ROUTES.COMMUNITY_TOOLS.FEED_POSTS.DETAILS,
  ],
  feedPostResults: [
    ROUTES.COMMUNITY_TOOLS.BASE,
    ROUTES.COMMUNITY_TOOLS.FEED_POSTS.BASE,
    ":feedPostId",
    ROUTES.COMMUNITY_TOOLS.FEED_POSTS.DETAILS,
    ROUTES.COMMUNITY_TOOLS.FEED_POSTS.RESULTS,
  ],
  manageChannels: [
    ROUTES.COMMUNITY_MANAGEMENT.BASE,
    ROUTES.COMMUNITY_MANAGEMENT.MANAGE_CHANNELS,
  ],
  updateSchoolProfile: [
    ROUTES.COMMUNITY_MANAGEMENT.BASE,
    ROUTES.COMMUNITY_MANAGEMENT.UPDATE_SCHOOL_PROFILE,
  ],
  dataManagement: [
    ROUTES.COMMUNITY_MANAGEMENT.BASE,
    ROUTES.DATA_MANAGEMENT.BASE,
  ],
  manageAccounts: [ROUTES.SETTINGS.BASE, ROUTES.SETTINGS.MANAGE_ACCOUNTS],
  notificationSettings: [
    ROUTES.SETTINGS.BASE,
    ROUTES.SETTINGS.NOTIFICATION_SETTINGS,
  ],
  channelRequest: [
    ROUTES.COMMUNITY_MANAGEMENT.BASE,
    ROUTES.COMMUNITY_MANAGEMENT.CHANNEL_REQUEST,
  ],
  components: [ROUTES.COMPONENTS],
  manageProfile: [ROUTES.MANAGE_PROFILE.BASE],
  editProfile: [ROUTES.MANAGE_PROFILE.BASE, ROUTES.MANAGE_PROFILE.YOUR_PROFILE],
  editFunFacts: [ROUTES.MANAGE_PROFILE.BASE, ROUTES.MANAGE_PROFILE.FUN_FACTS],
  editSocials: [ROUTES.MANAGE_PROFILE.BASE, ROUTES.MANAGE_PROFILE.SOCIALS],
  editContactInfo: [
    ROUTES.MANAGE_PROFILE.BASE,
    ROUTES.MANAGE_PROFILE.CONTACT_INFO,
  ],
  editNotifications: [
    ROUTES.MANAGE_PROFILE.BASE,
    ROUTES.MANAGE_PROFILE.NOTIFICATIONS,
  ],
  editPassword: [ROUTES.MANAGE_PROFILE.BASE, ROUTES.MANAGE_PROFILE.PASSWORD],
  strategy: [ROUTES.RISE.BASE, ROUTES.RISE.STRATEGY],
  impact: [ROUTES.RISE.BASE, ROUTES.RISE.IMPACT],
  rise: [ROUTES.RISE.BASE],
};

export type RouteId = keyof typeof ROUTE_MAP;

export const useRoute = () => {
  const { orgId } = useParams();
  return (
    routeId: RouteId,
    params: Record<string, string> = {},
    query?: UrlQueryObject,
    includeDomain = false,
  ) => {
    const path =
      (includeDomain ? window.location.origin : "") +
      "/" +
      BASE_ROUTE +
      "/" +
      ROUTE_MAP[routeId].join("/");
    const generatedPath = generatePath(path, { orgId, ...params });

    if (query && Object.keys(query).length > 0) {
      const searchParams = convertToQueryString(query);
      return generatedPath + "?" + searchParams;
    }

    return generatedPath;
  };
};
